module.exports = __webpack_public_path__ + "static/pizza57-9345b0780e3c0b1d4399bf1b5227797f.webp";